import React from 'react';

const HeroGreeting = () => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
    const formattedTime = today.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

    return (
        <div style={{ marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div>
                <h1 style={{ margin: 0, fontSize: '20px', color: '#1F1F1F', letterSpacing: '-0.5px' }}>Dashboard</h1>
                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                    JP Soni · Manoj Abhushan Bhandar
                </div>
            </div>
            <div style={{ textAlign: 'right', fontSize: '12px', color: '#888' }}>
                Last updated: Today, {formattedTime}
            </div>
        </div>
    );
};

export default HeroGreeting;
